var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#ee342e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.726 59.714c1.324-3.147 4.449-6.478 9.375-9.994 4.275-3.06 7.042-5.252 8.3-6.575 1.932-2.062 2.898-4.319 2.898-6.771 0-1.997-.554-3.657-1.66-4.98-1.107-1.325-2.691-1.986-4.753-1.986-2.821 0-4.742 1.052-5.762 3.157-.586 1.215-.933 3.147-1.041 5.794h-9.017c.152-4.014.879-7.259 2.18-9.733 2.475-4.709 6.87-7.064 13.184-7.064 4.992 0 8.963 1.384 11.914 4.15 2.952 2.768 4.428 6.43 4.428 10.987 0 3.494-1.042 6.597-3.125 9.31-1.368 1.801-3.614 3.809-6.739 6.022l-3.71 2.637c-2.323 1.65-3.912 2.843-4.77 3.58a10.493 10.493 0 0 0-2.164 2.572h20.605v8.17H28.545c.087-3.384.814-6.477 2.18-9.276Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.d1e04ba18750166ea1a4292b7c8667e4.svg";
export { ForwardRef as ReactComponent };